import Vue from 'vue';
import vuex from 'vuex';
import axios from 'axios';
Vue.use(vuex)

export default new vuex.Store({
    state: {
      allData:'',
      languagesData:'',
      lighted:'index',
      language:'english',
      detailsData:'',
      detailData:''
    },
    mutations: {
      languagesDataFun(state,data){
        state.allData=data;
        state.languagesData=data.english;
      },
      changeLanguage(state,language){
        state.languagesData=state.allData[language];
        state.language=language;
        if (state.detailsData) {
          state.detailData=state.detailsData[language];
        }
      },
      highLighted(state,type){
        state.lighted=type;
      },
      detailFun(state,data){
        state.detailsData=data;
        state.detailData=data[state.language];
      }
    },
    getters: {},
    actions: {
      getData(){
        return new Promise(resolve=>{
          axios.get('/static/language.json').then(res => {
              this.commit("languagesDataFun",res.data.data);
              resolve(res)
          })
        })
      },
      getDetail(context,id){
        return new Promise(resolve=>{
          axios.get('/static/news/'+id +'.json').then(res => {
            this.commit("detailFun",res.data.data);
          }).catch(res=>{
            this.commit("detailFun",'');
          })
        })
      }
    },
    modules: {}
})



// WEBPACK FOOTER //
// ./src/store/index.js